import React, { ReactNode } from "react";
import { Box } from "@mui/material";

type ConsoleLogProps = {
  children: ReactNode;
};

const ConsoleLog = (props: ConsoleLogProps) => {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.common.black,
        px: 1,
        borderRadius: "8px",
        minWidth: "6rem",
      })}
    >
      {props.children}
    </Box>
  );
};

export default ConsoleLog;
